#import "~/graphql/fragments/CraftLink.graphql"

fragment DefaultHero on defaultHero_Entry {
    title
    subtitle
    cta {
        ... CraftLink
    }
    footer
}
